import Market from "@/views/market/Market";
import Book from "@/views/market/Book";
import MarketCatalog from "@/views/market/MarketCatalog";
import BookInfo from "@/views/market/BookInfo";
import CourseInfo from "@/views/market/CourseInfo";
import Course from "@/views/market/Course";

export default {
    path: 'market',
    component: Market,
    name: 'market',
    meta: { title: 'Market' },
    children: [
        {
            path: 'catalog',
            component: MarketCatalog,
            name: 'market-catalog',
            meta: { title: 'Market' },
        },
        {
            path: 'book/:id',
            component: Book,
            name: 'market-book',
            meta: { title: 'Book page' },
        },
        {
            path: 'book/:id/info',
            component: BookInfo,
            name: 'market-book-info',
            meta: { title: 'Book info page' },
        },
        {
            path: 'course/:id',
            component: Course,
            name: 'market-course',
            meta: { title: 'Course page' },
        },
        {
            path: 'course/:id/info',
            component: CourseInfo,
            name: 'market-course-info',
            meta: { title: 'Course info page' },
        }
    ]
}